module.exports = __webpack_public_path__ + "img/warning-red.893c8694.svg";